const CANONICAL_APP_ORIGIN = 'https://app.webelievesoftware.com';

function normalizePath(path: string): string {
  return path.startsWith('/') ? path : `/${path}`;
}

export function getBackendApiOrigin(): string {
  const configuredBase = import.meta.env.VITE_API_BASE_URL;

  if (configuredBase) {
    return configuredBase.replace(/\/$/, '');
  }

  if (typeof window !== 'undefined' && window.location.hostname === 'webelievesoftware.com') {
    return CANONICAL_APP_ORIGIN;
  }

  return '';
}

export function getBackendApiUrl(path: string): string {
  return `${getBackendApiOrigin()}${normalizePath(path)}`;
}

export function getBackendApiBaseUrl(path = '/api/v1'): string {
  return getBackendApiUrl(path);
}
